export const DAValidator = (value, component) => {
  var str = /^[0-9]{3}[\/][\w]*[\/][0-9]{2}$/g;
  var patt = str;
  return patt.test(value);
}



// WEBPACK FOOTER //
// ./resources/assets/js/validators/development-application-validator.js